import { BodyText, Button, CloseIcon, IconButton } from '@farol-ds/react'
import {
  PersistentAlertBannerIcon,
  PersistentAlertBannerLink,
} from '@jusbrasil-web/shared-apollo-client/types'
import { useUserSession } from '@jusbrasil-web/shared-user-session'
import { useEffect, useState } from 'react'

import { usePersistentAlertBannerDispatcher } from '../../hooks'
import { studentsBenefitPersistentAlertBannerPersisted } from '../../utils'
import { AlertIcon } from '../alert-icon'
import styles from './students-benefit.module.scss'

const CLOSE_LABEL = 'Fechar'
const REGION_LABEL = 'Benefício para estudantes de direito'

interface StudentsBenefitProps {
  text?: string | null
  description?: string | null
  icon?: PersistentAlertBannerIcon | null
  link?: PersistentAlertBannerLink | null
}

export function StudentsBenefit({ text, description, icon, link }: StudentsBenefitProps) {
  const { sendTopbarEvent, ref } = usePersistentAlertBannerDispatcher<HTMLDivElement>()
  const user = useUserSession()

  const [isVisible, setIsVisible] = useState(true)

  const handleClose = () => {
    studentsBenefitPersistentAlertBannerPersisted.set(user?.pid?.toString())
    sendTopbarEvent('StudentsBenefitToastClosed')
    setIsVisible(false)
  }

  const handleCtaClick = () => {
    studentsBenefitPersistentAlertBannerPersisted.set(user?.pid?.toString())
    sendTopbarEvent('StudentsBenefitToastClicked')
  }

  useEffect(() => {
    if (isVisible) {
      sendTopbarEvent('StudentsBenefitToastView')
    }
  }, [isVisible, sendTopbarEvent])

  if (!isVisible) return null

  return (
    <div ref={ref} role="region" aria-label={REGION_LABEL} className={styles.root}>
      <div className={styles.layout}>
        <div className={styles.textBlock}>
          {icon && <AlertIcon icon={icon} size="sm" className={styles.icon} aria-hidden />}
          <div className={styles.textColumn}>
            {text && (
              <BodyText size="lg" className={styles.title}>
                <strong>{text}</strong>
              </BodyText>
            )}
            {description && (
              <BodyText size="md" className={styles.description}>
                {description}
              </BodyText>
            )}
          </div>
        </div>

        {link?.url && link?.label && (
          <Button kind="tertiary" size="md" className={styles.cta} onClick={handleCtaClick} asChild>
            <a href={link.url}>{link.label}</a>
          </Button>
        )}

        <IconButton
          icon={<CloseIcon />}
          label={CLOSE_LABEL}
          size="md"
          kind="plain"
          className={styles.closeButton}
          onClick={handleClose}
        />
      </div>
    </div>
  )
}
